import { useTranslation } from "react-i18next";
import PageContainer from "../components/layouts/PageContainer";
import FilesDrawer from "../components/layouts/files/Drawer";
import { useContext, useEffect, useState } from "react";
import FileContext from "../context/files/FileContext";
import SelectedFile from "../components/layouts/files/SelectedFile";
import NewFileModal from "../components/layouts/files/NewFileModal/NewFileModal";

const Files = () => {
	const { getFiles, getFilesLoading } = useContext(FileContext);
	const [selectedFile, setSelectedFile] = useState(null);
	const [isNewFileModalOpen, setIsNewFileModalOpen] = useState(false);
	const [isDrawerExpanded, setIsDrawerExpanded] = useState(true);
	const { t } = useTranslation();

	useEffect(() => {
		getFiles("kon");
	}, []);

	return (
		<PageContainer title={t("files")}>
			<NewFileModal isOpen={isNewFileModalOpen} onClose={() => setIsNewFileModalOpen(false)} />
			<div style={{ display: "flex", width: "100%", height: "100%" }}>
				<FilesDrawer
					isLoading={getFilesLoading}
					isExpanded={isDrawerExpanded}
					selectedFile={selectedFile}
					setIsExpanded={setIsDrawerExpanded}
					setSelectedFile={setSelectedFile}
					setIsNewFileModalOpen={setIsNewFileModalOpen}
				/>

				<SelectedFile
					isDrawerExpanded={isDrawerExpanded}
					file={selectedFile}
					onBackClick={() => setSelectedFile(null)}
				/>
			</div>
		</PageContainer>
	);
};

export default Files;
